import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Button } from "../../components/ui/forms/Button";
import NoPatron from "../../components/layout/Pane/NoPatron";
import { DeletePatronModal } from "../../components/Patrons/DeletePatronModal";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import { UserContext } from "../../contexts/UserContext";
import { OrderContext } from "../../contexts/OrderContext";
import { PatronContext } from "../../contexts/PatronContext";
import { PaneContext } from "../../contexts/PaneContext";
import { PatronDetails } from "../../components/Patrons/PatronDetails";
import Details from "../../components/Ordering/Details";
import { Icon } from "@material-ui/core";

const OrderCard = () => {
  const { patron } = useContext(PatronContext);
  const { addPatronToOrder } = useContext(OrderContext);
  const { newPatronMode } = useContext(PaneContext);
  const { Site } = useContext(UserContext);
  const { deletableRecords, siteType } = Site;
  const patronLabel = siteType === 0 || siteType === 5 ? "Student" : "Staff";

  const [modal, setModal] = useState(false);

  const openModal = () => {
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
  };

  return !patron.externalID && !newPatronMode ? (
    <NoPatron />
  ) : (
    <Container>
      {!newPatronMode && <PatronDetails patron={patron} />}

      {!newPatronMode && (
        <Actions>
          <Button
            colour="success"
            onClick={() => addPatronToOrder(patron)}
            margin="0 0 1rem 0"
          >
            <AddIcon style={{ marginRight: "5px" }} />
            Order card
          </Button>

          {deletableRecords && (
            <Button colour="error" onClick={() => openModal()}>
              <CloseIcon style={{ marginRight: "5px" }} />
              Delete {patronLabel}
            </Button>
          )}
        </Actions>
      )}

      <Details />

      <DeletePatronModal open={modal} close={closeModal} patron={patron} />
    </Container>
  );
};

const Container = styled.div`
  padding: 2rem;
  position: relative;
`;

const Actions = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`;

export default OrderCard;
